module.exports = function getResource(label, vars = []) {
    let resources = {
        close: 'Close',
        shopNow: 'Shop now, pay later',
        interestFree: '4 interest-free payments of',
        addItems: 'Add items you love to your basket.',
        choose: 'Choose',
        atCheckout: 'at checkout',
        purchaseSplit: 'Your purchase will be split into four equal, interest-free payments. The first is due when your order is shipped.',
        remainingPayment: 'The remaining three payments will be automatically charged to your debit or credit card every two weeks.',
        learnMore: 'Learn more',
        completeTerms: 'See complete terms.',
        californiaTerms: 'For CA residents, loans made or arranged are pursuant to a California Finance Lenders Law license.',
        caTermFirst: 'Pay later in 4 terms available ',
        caTermLinkFirst: 'here',
        caTermSecond: 'For Quebec residents these Pay later in 4 ',
        caTermLinkSecond: 'terms',
        caTermsThird: 'are applicable.',
        gotIt: 'Got It',
        pbBuyNowPayLater: 'Buy Now, Pay Later',
        pbInterestFreePayments: 'in 4 bi-weekly interest-free payments',
        pbPayAsLittleAs: `Pay as little as ${vars[0]} in 4 installments based on a purchase price of ${vars[1]} at 0% APR.`,
        pbInstantDecision: 'Instant Decision',
        pbEnterFewDetails: 'Enter a few details to get a real-time decision.',
        pbEasyPayments: 'Easy Payments',
        pbAutomaticCharge: 'Automatically charged to your preferred method of payment.',
        pbSimplySelect: 'Simply select PayBright at checkout.',
        pbTermsFirst: '*Estimated bi-weekly payment amount excludes taxes, shipping, and other fees. Some conditions apply and all transactions are subject to approval by PayBright. Visit',
        pbFAQ: 'PayBright FAQ',
        pbTermsSecond: 'for further information.'
    };

    return resources[label];
};
